import bee from "./Bee";
export default {
    name: "Promotions",
    /*
        var query = {
           
        }
    */
    /* eslint-disable no-unused-vars */
    get_featured_promotions(query,success,fail){
        //nyd 
        //for now just do this
        success([{
            id: 34,
            title: 'Sep Month End It is what i want to tell all of you',
            business: {
                id: 4,
                name: "Choopies (pty) Ltd"
            }
        },{
            id: 35,
            title: 'Greate Savings Season',
            business: {
                id: 4,
                name: "Sefalana General Dearlers (pty) ltd"
            }
        }]);
    },
    /*
        var query = {
            promotion_id: 3,
            user_id: 34,
            page: "",
            section: ""
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_featured_promotion(query,success,fail){
        //context: "featured_promotion"
        bee.post({
            promotion_view:{
                ...query,
                context: "featured_promotion",
                view_on: "1989-01-01",
                _time_view_on_timestamp: "1989-01-01"
            }
        })
        .then(res => {
            if(success){
                success(res.promotion_view);
                //nyd
                //build a report under admin side for this
            }
        })
        .catch(errors => {
            if(fail){
                fail(errors);
            }
        });
    },
    /*
        var query = {
            advert_name: 3,
            user_id: 34,
            page: "",
            section: ""
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_self_promotion(query,success,fail){
        bee.post({
            self_promotion_click:{
                ...query,
                view_on: "1989-01-01",
                _time_view_on_timestamp: "1989-01-01"
            }
        })
        .then(res => {
            if(success){
                success(res.self_promotion_click);
                //nyd
                //build a report under admin side for this
            }
        })
        .catch(errors => {
            if(fail){
                fail(errors);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    get_new_count(query,success,fail){
        bee.get({
            promotions:{
                _a: " _count ",
                _w: [
                    ["has_been_ended","e",0]
                ]
            }
        }).then(
            res => {
                if(success){
                    success(res.promotions[0].count);
                }
            }
        ).catch(errors => {
            if(fail){
                fail(errors);
            }
        });
    }
}